const types = {
  FETCH_CURRENT_PERMIT: "FETCH_CURRENT_PERMIT",
  REMOVE_CURRENT_PERMIT: "REMOVE_CURRENT_PERMIT",
  ADD_PERMIT: "ADD_PERMIT",
  FETCH_CURRENT_CREDITS: "FETCH_CURRENT_CREDITS",
  FETCH_USED_CREDITS: "FETCH_USED_CREDITS",
  FETCH_CREDITS_ALLOCATED: "FETCH_CREDITS_ALLOCATED",
  FETCH_PAST_CREDITS_ALLOCATED: "FETCH_PAST_CREDITS_ALLOCATED",
  FETCH_CREDITS_30DAYS_REEPORTS: "FETCH_CREDITS_30DAYS_REEPORTS",
  FETCH_DATE_LIST: "FETCH_DATE_LIST",
  FETCH_RESIDENTSCREDITSARR: "FETCH_RESIDENTSCREDITSARR",
  FETCH_RESIDENTSPASTCREDITSARR: "FETCH_RESIDENTSPASTCREDITSARR",
  FETCH_CREDITS: "FETCH_CREDITS",
  SET_AVAILABLESPOTS: "SET_AVAILABLESPOTS",
  FETCH_RESIDENTS_PERMIT: "FETCH_RESIDENTS_PERMIT",
  REMOVE_SPECIFIC_PERMIT: "REMOVE_SPECIFIC_PERMIT",
  CALL_WHEN_HERE_ACTIVATE_DEACTIVATE: "CALL_WHEN_HERE_ACTIVATE_DEACTIVATE",
  UPDATE_CURRENT_PERMIT: "UPDATE_CURRENT_PERMIT",
  FETCH_TIME_SLOT: "FETCH_TIME_SLOT",
  FETCH_CREDITS_USED_30DAYS: "FETCH_CREDITS_USED_30DAYS",
  FETCH_RESIDENT_LIST: "FETCH_RESIDENT_LIST",
  FETCH_SINGLE_CREDIT_AVAILABILITY: "FETCH_SINGLE_CREDIT_AVAILABILITY",
  UPDATE_PERMIT: "UPDATE_PERMIT",
  UPDATE_PERMIT_SUCCESS: "UPDATE_PERMIT_SUCCESS",
  UPDATE_PERMIT_ERROR: "UPDATE_PERMIT_ERROR",
  DELETE_VISITOR: "DELETE_VISITOR",
  GET_SHARED_LOT: "GET_SHARED_LOT",
};

export default types;
